import { APIClient } from "./axiosClient";

const api = new APIClient();
const path = '/voc';

const vocManaApi = {
  triggerEvents(params: any): Promise<any> {
    const url = `${path}`
    return api.get(url, params)
  },

  vocList(params: any): Promise<any> {
    const url = `${path}`
    return api.get(url, params)
  },

  deleteVOCList(id: string | number): Promise<any> {
    const url = `${path}/${id}`;
    return api.delete(url)
  },

  vocReasons(params: any): Promise<any> {
    const url = `${path}/reason`
    return api.get(url, params)
  },

  vocReasonsAll(params: any): Promise<any> {
    const url = `${path}/reason/all`
    return api.get(url, params)
  },

  getVOCReason(id: string | number, params: any = {}): Promise<any> {
    const url = `${path}/${id}`;
    return api.get(url, params)
  },

  postVOCReason(dataForm: any): Promise<any> {
    const url = `${path}/reason`;
    return api.post(url, dataForm)
  },

  putVOCReason(id: string | number, dataForm: any): Promise<any> {
    const url = `${path}/reason/${id}`;
    return api.put(url, dataForm)
  },

  deleteVOCReason(id: string | number, dataForm: any): Promise<any> {
    const url = `${path}/reason/${id}`;
    return api.delete(url, dataForm)
  },

  allOperators(params: any = {}): Promise<any> {
    const url = `masters/admins`
    return api.get(url, params)
  },
}
export default vocManaApi
